import React from 'react'
import parse from 'html-react-parser'
import styled from 'styled-components'

export default (props) => {
    return (
        <Styles>
            <article className="article" id={'blog' + props.id}>
                <h1>{props.title}</h1>
                <div><p className="tag-div">{props.tag}</p></div>
                <img src={props.image} alt="blog" className="blog-image" />
                {parse(props.body)}
                <img src={props.image2} alt="blog" className="blog-image2" />
                {parse(props.body2)}
                <hr></hr>
            </article>
        </Styles>
    )
}

const Styles = styled.div`
.article{
    text-align:justify;
    padding-top: 20%;
    margin-top: -20%;
}
.article h1, h3{
    text-align:left;
}
.blog-image, .blog-image2{
    max-width:100%;
    max-height:50%;
    margin-top:3%;
    margin-bottom:3%;
}
.tag-div{
    display:inline;
    margin-left: 5px;
    margin-top:5px;
    background-color:#80a8a0;
    color:white;
    border-radius:5px;
    padding:2px 4px 2px 4px;
}
hr{
    border:0.3px solid #45908b;
}

@media (max-width: 1024px) {
    .article{
        padding-top: 25%;
        margin-top: -25%;
    }
}
`